module.exports = __webpack_public_path__ + "static/media/externalBarn_4.8ec6bfef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_4.png
// module id = 1308
// module chunks = 3